import React from 'react';
import { Box, Typography } from '@mui/material';

function Page1SubPageE() {
  return (
    <Box p={4}>
      <Typography variant="h4">Recommended</Typography>
    </Box>
  );
}

export default Page1SubPageE;
